module.exports = __webpack_public_path__ + "img/edition_1.522a1104.png";